import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { availableOrderQuantity } from '../utils/orderAvailability';
import { productImagePaths } from '../utils/productImages';

export const useBasketStore = create(
  persist(
    devtools((set, get) => ({
      products: [],
      patchProduct: payload => {
        const products = get().products.map(product => {
          return product.id === payload.id ? payload : product;
        });

        set(() => ({
          products,
        }));
      },

      setOnlyProductTooltip: productId => {
        set(state => ({
          products: state.products.map(p => ({
            ...p,
            showTooltip: p.id === productId,
          })),
        }));
      },

      clearAllTooltips: () => {
        set(state => ({
          products: state.products.map(p =>
            p.showTooltip ? { ...p, showTooltip: false } : p,
          ),
        }));
      },

      addProduct: (product, quantity = 1) => {
        const image = productImagePaths(product)[0] || '';
        const maxQuantity = product.quantity;

        let cartProduct = {
          id: product.id,
          image: image,
          name: product.name,
          price: product.price,
          discountedPrice: product.discountedPrice,
          personalDiscount: product.personalDiscount,
          productDiscount: product.productDiscount,
          quantity: quantity,
          maxQuantity: maxQuantity,
          showTooltip: false,
          dateAdded: Date.now(),
          state: product.state,
          stockQuantity: product.stockQuantity,
          preorderQuantity: product.preorderQuantity,
          toOrder: quantity > availableOrderQuantity(product),
          expectedArrivalDate: product.expectedArrivalDate || null
        };

        set(() => ({ products: [...get().products, cartProduct] }));
      },

      deleteProductById: id => {
        set(state => ({
          ...state,
          products: state.products.filter(product => product.id !== id),
        }));
      },
      deleteProductsByIds: ids => {
        set(state => ({
          ...state,
          products: state.products.filter(product => !ids.includes(product.id)),
        }));
      },
      clearBasket: () => {
          set(state => ({
              ...state,
              products: []
          }));
      },

      handleStorageChange: event => {
        if (event.key === 'cart') {
          const newValue = JSON.parse(event.newValue);
          set({ products: newValue.state.products });
        }
      },

      setProducts: newProducts => {
        set(() => ({ products: newProducts }));
      },
    })),

    {
      name: 'cart', 
      storage: createJSONStorage(() => localStorage), 
    },
  ),
);

window.addEventListener('storage', useBasketStore.getState().handleStorageChange);
